// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dialog":"dialog_gPp+D","ui_mask":"ui_mask_G22Gn"};